import React from "react";
import "./Loader.scss";

export interface IPennyDropLoaderProps {
  color?: "grey" | "blue";
  size?: 18 | 20 | 100;
}

const PennyDropLoader: React.FC<IPennyDropLoaderProps> = (
  props: IPennyDropLoaderProps
) => {
  const color = props.color || "grey";
  return (
    <div
      className="Loading-animation"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="Validating bank account, please wait"
    >
      <div className="trail"></div>
      <div className="icon"></div>
      <span className="sr-only">Validating bank account, please wait…</span>
    </div>
  );
};

export default PennyDropLoader;
